import language from "../languages";
import homeIcon from "../assets/img/menu/beranda.png";
import financeIcon from "../assets/img/menu/penganggaran.png";

export const SIDEBAR__DASHBOARD_MENU = [
  {
    title: language.translate.SIDEBAR__HOME,
    iconImage: homeIcon,
    path: "/dashboard",
  },
  {
    title: "Tagihan Siswa",
    className: "menu__left-icon--small",
    path: "/dashboard/tagihan-siswa",
    iconImage: financeIcon,
    menu: [
      {
        title: "Pembayaran",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 40,
        path: "/dashboard/tagihan-siswa/pembayaran",
        permission: "view_student",
      },
      {
        title: "Riwayat Pembayaran",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 40,
        path: "/dashboard/tagihan-siswa/riwayat",
        permission: "view_student",
      },
      {
        title: "Rincian Pembayaran",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 40,
        path: "/dashboard/tagihan-siswa/rincian-pembayaran",
        permission: "view_student",
      },
    ],
  },
  // {
  //   title: language.translate.SIDEBAR__SETTING,
  //   iconImage: settingIcon,
  //   menu: [
  //     {
  //       title: "Ganti Kata Sandi",
  //       path: "/dashboard/pengaturan/ganti-kata-sandi",
  //     },
  //   ],
  // },
];

export const SIDEBAR_ADMISSION_MENU = [
  {
    title: language.translate.SIDEBAR__HOME,
    iconImage: homeIcon,
    path: "/admission",
  },
];
